import { render, staticRenderFns } from "./CmgFeatured.vue?vue&type=template&id=0b19bba8&scoped=true&lang=pug"
import script from "./cmg-featured.ts?vue&type=script&lang=ts&external"
export * from "./cmg-featured.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgFeatured.vue?vue&type=style&index=0&id=0b19bba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b19bba8",
  null
  
)

export default component.exports